import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#003657',
        secondary: '#424242',
        tertiary: '#495057',
        accent: '#82B1FF',
        error: '#d3223c',
        info: '#2196F3',
        success: '#228B22',
        warning: '#ffa500'
      },
    },
  },
  icons: {
    iconfont: 'mdi',
    values : {
      document: "mdi-file-document-outline",
      estate: "mdi-home",
      company: "mdi-domain",
      notification: "mdi-information-variant",
      activity: "mdi-check",
      email: "mdi-email-outline",
      error: "mdi-cancel",
      read: "mdi-eye-outline",
      signed: "mdi-feather",
      start: "mdi-clock-fast",
      completed: "mdi-check",
      filled: "mdi-file-check"
    }
  },
});
